import Vue from 'vue'
import directive from './directive' // directive

Vue.use(directive)
